import { Trans } from '@lingui/react';
import styled from 'styled-components';
import { Box, Flex } from '@components/layout/Grid';
import Span from '@components/layout/Span';
import { P } from '@components/typography/Paragraph';
import Button from '@components/buttons';
import InstructorModal from '@organisms/modals/InstructorModal';
import { ArrowRightIcon } from '@assets/index';

export const Thumbnail = styled(Box)`
  width: 65px;
  height: 65px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`;

const Paragraph = styled(P)`
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
`;

const InstructorWrapper = styled(Flex)`
  align-items: flex-start;
  > *:not(:last-child) {
    margin-right: 30px;
  }
`;

const InstrcutorDetailsWrapper = styled(Flex)`
  flex-direction: column;
  > *:not(:last-child) {
    margin-right: 10px;
  }
`;

const ReadMoreButton = styled(Button)`
  display: flex;
  align-items: center;

  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  margin-top: 10px;

  svg {
    width: 16px;
    margin-left: 5px;

    path {
      fill: currentColor;
    }
  }
`;

export const SmallWrapper = styled(Flex)`
  > *:not(:last-child) {
    margin-right: 20px;
  }

  align-items: center;

  cursor: pointer;

  .instructor-name {
    span {
      font-size: 16px !important;
      font-weight: 600 !important;
      letter-spacing: 0 !important;
      line-height: 23px !important;
    }

    margin-bottom: 0;
  }

  ${Thumbnail} {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
  }
`;

interface InstructorCardProps {
  name: string;
  thumbnailUrl?: string;
  slug: string;
  description?: string;
  variant?: 'default' | 'small';
}

const InstructorCard = ({
  variant = 'default',
  ...props
}: InstructorCardProps) => {
  const content = (
    <InstructorWrapper>
      <InstrcutorDetailsWrapper>
        <Box>
          <Box className="instructor-name" mb="10px">
            <Span
              className="instructor-name"
              data-testid="InstructorCard--Name"
              bold
            >
              {props.name}
            </Span>
          </Box>
          {variant === 'default' && (
            <Box mt={0} as={Paragraph} data-testid="InstructorCard--Desc">
              {props.description}
            </Box>
          )}
        </Box>
      </InstrcutorDetailsWrapper>
    </InstructorWrapper>
  );

  const modalContent = handleOpenModal => {
    const first_name = props.name.split(' ')[0];
    if (variant === 'default') {
      return (
        <ReadMoreButton
          appearance="link"
          onClick={handleOpenModal}
          data-testid="InstructorCard--ReadMore"
        >
          <Trans id="metadata.visit_profile" values={{ name: first_name }} />
          <ArrowRightIcon />
        </ReadMoreButton>
      );
    }

    if (variant === 'small') {
      return (
        <SmallWrapper onClick={handleOpenModal}>
          {props.thumbnailUrl ? (
            <Thumbnail backgroundColor="#e9e9e9">
              <img src={props.thumbnailUrl} />
            </Thumbnail>
          ) : null}
          {content}
        </SmallWrapper>
      );
    }
  };

  return (
    <InstructorWrapper data-testid="InstructorCard">
      {props.thumbnailUrl && variant === 'default' ? (
        <Thumbnail flex="0 0 65px" backgroundColor="#e9e9e9">
          <img src={props.thumbnailUrl} />
        </Thumbnail>
      ) : null}
      <InstrcutorDetailsWrapper flexDirection="column">
        {variant === 'default' && content}
        <InstructorModal slug={props.slug} data-testid="InstructorModal">
          {modalContent}
        </InstructorModal>
      </InstrcutorDetailsWrapper>
    </InstructorWrapper>
  );
};

export default InstructorCard;
